import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    Email: { label: i18n.t('contact_email.entity_name'), value: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'Email', title: i18n.t('contact_email.entity_name'), columnMenu: 'myTemplate', locked: false },
  ] 
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
